import { apiSlice } from "../../apiSlice";

const headers = { Modulecima: "Ordtraxx" };

export const TareasxxApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    validatePermissionAdmin: builder.query({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/validatePermissionAdmin`,
        params: { ...parameters },
      }),
    }),
    validateSyncReco: builder.query({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/validateSyncReco/${parameters.TARIDXXX}`,
      }),
    }),
    validateSyncRecoMassive: builder.query({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/validateSyncRecoMassive`,
        params: { ...parameters },
      }),
    }),
    getUserResolve: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/getUserResolve`,
        params: { ...parameters },
      }),
    }),
    //Tareas de la misma cadena (Gestion Contable -> pago -> tesoreria)
    getRelatedTasks: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/getRelatedTasks/${parameters.TARIDXXX}`,
        headers,
      }),
    }),
    getAllTasks: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx`,
        params: { ...parameters },
        headers,
      }),
    }),
    updateTask: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/${parameters.TARIDXXX}`,
        method: "PUT",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    changeStatusTask: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/changeStatus/${parameters.TARIDXXX}`,
        method: "PUT",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    getEstadosCims30: builder.query({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/getEstadosCims30`,
        params: { ...parameters },
      }),
    }),
    saveTaskGeneral: builder.mutation({
      query: (parameters) => ({
        url: "/Ordtraxx/Cretarxx",
        method: "POST",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    updateTaskGeneral: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Cretarxx/${parameters.TARIDXXX}`,
        method: "PUT",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    getMotivesRejection: builder.query({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/getMotivesRejection`,
        params: { ...parameters },
      }),
    }),
    addFollowUp: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/addFollowUp/${parameters.TARIDXXX}`,
        method: "PUT",
        body: { ...parameters.data },
      }),
      invalidatesTags: ["Create"],
    }),
    getFollowUps: builder.query({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/getFollowUps?page=${parameters.page}&per_page=15`,
        method: "GET",
        params: { ...parameters },
      }),
    }),
    saveFollowUps: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/followUps`,
        method: "POST",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    getTributos: builder.query({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/getDataTributos`,
        params: { ...parameters },
      }),
    }),
    getPucByTributos: builder.query({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/getPucByTributos`,
        params: { ...parameters },
      }),
    }),
    getProvAsigvuce: builder.query({
      query: ({ TARIDXXX }) => ({
        url: `/Ordtraxx/Tareasxx/getProvAsigvuce/${TARIDXXX}`,
        method: "GET",
      }),
    }),
    getDetailTask: builder.query({
      query: ({ TARIDXXX }) => ({
        url: `/Ordtraxx/Tareasxx/getDetailTask/${TARIDXXX}`,
        method: "GET",
      }),
    }),
    getConsultProduct: builder.query({
      query: ({ TARIDXXX }) => ({
        url: `/Ordtraxx/Tareasxx/getConsultProduct/${TARIDXXX}`,
        method: "GET",
      }),
    }),
    getShortLinkChildTask: builder.query({
      query: ({ TARIDXXX }) => ({
        url: `/Ordtraxx/Tareasxx/getShortLinkChildTask/${TARIDXXX}`,
        method: "GET",
      }),
    }),
    getShortLinkByModule: builder.query({
      query: ({ TARIDXXX, filters = "" }) => ({
        url: `/Ordtraxx/Tareasxx/getShortLinkByModule/${TARIDXXX}?` + filters,
        method: "GET",
      }),
    }),
    saveTaskConcepCobro: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/saveTaskConcepCobro/${parameters.CONCOBID}`,
        method: "PUT",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    getExternalAdminUsers: builder.query({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/getAdminResolve`,
        params: { ...parameters },
      }),
    }),
    getDetailProduct: builder.query({
      query: ({ TARIDXXX }) => ({
        url: `/Ordtraxx/Tareasxx/getDetailProduct/${TARIDXXX}`,
        method: "GET",
      }),
    }),
    approveOrDecline: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/approveOrDecline/${parameters.TARIDXXX}`,
        method: "PUT",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    asigDescMin: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/asigDescMin`,
        method: "POST",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    getUsers: builder.query({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/getUsers/${parameters.USRIDXXX}`,
        method: "GET",
      }),
    }),
    getProvInvoice: builder.query({
      query: ({ TARIDXXX }) => ({
        url: `/Ordtraxx/Tareasxx/getProvInvoice/${TARIDXXX}`,
        method: "GET",
      }),
    }),
    getChildTask: builder.query({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/getChildTask`,
        method: "GET",
        params: parameters,
        headers,
      }),
    }),
    getCountryProv: builder.query({
      query: ({ TARIDXXX }) => ({
        url: `/Ordtraxx/Tareasxx/getCountryProv/${TARIDXXX}`,
        method: "GET",
      }),
    }),
    updateResCheduleTask: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/resChedule/${parameters.TARIDXXX}`,
        method: "PUT",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    uploadMassiveResCheduleTasks: builder.mutation({
      query: ({ file }) => {
        const formData = new FormData();
        formData.append("file", file);
        return {
          url: `/Ordtraxx/Tareasxx/fileUploadResChedule`,
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
          },
        };
      },
      invalidatesTags: ["Create"],
    }),
    scheduleTaskById: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/scheduleTaskById/${parameters.TARIDXXX}`,
        method: "PUT",
        params: { ...parameters },
      }),
      invalidatesTags: ["Create"],
    }),
    getUrlRedirectionTask: builder.mutation({
      query: ({ MODIDXXX, PROIDXXX, ...query }) => ({
        url: `/Ordtraxx/Tareasxx/getUrlMod/${MODIDXXX}/${PROIDXXX}`,
        method: "GET",
        params: query,
      }),
    }),
    saveTaskAsodoent: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/Asodoent/${parameters.TARIDXXX}`,
        method: "PUT",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    getConsultOperation: builder.query({
      query: ({ TARIDXXX }) => ({
        url: `/Ordtraxx/Tareasxx/getConsultOperation/${TARIDXXX}`,
        method: "GET",
      }),
    }),
    getConsultDoVuce: builder.query({
      query: ({ TARIDXXX }) => ({
        url: `/Ordtraxx/Tareasxx/getConsultDoVuce/${TARIDXXX}`,
        method: "GET",
      }),
    }),
    getIndicatorsById: builder.query({
      query: ({ TARIDXXX }) => ({
        url: `/Ordtraxx/Tareasxx/getIndicatorsById/${TARIDXXX}`,
        method: "GET",
      }),
    }),
    updateTaskMassive: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Cretarxx/massiveReassignment`,
        method: "POST",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    getInfoTaskFather: builder.query({
      query: ({ TARIDXXX }) => ({
        url: `/Ordtraxx/Tareasxx/getInfoTaskFather/${TARIDXXX}`,
        method: "GET",
      }),
    }),
    canResolveTask: builder.query({
      query: ({ MODIDXXX, PROIDXXX, CLATARID }) => ({
        url: `/Ordtraxx/Tareasxx/canResolveTask/${MODIDXXX}/${PROIDXXX}/${CLATARID}`,
        method: "GET",
      }),
    }),
    saveDataCarrierDelivery: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/saveDataCarrierDelivery/${parameters.TARIDXXX}`,
        method: "PUT",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    solveMassiveTasks: builder.mutation({
      query: (parameters) => ({
        url: `/Ordtraxx/Tareasxx/solveMassiveTasks`,
        method: "PUT",
        body: parameters,
      }),
      invalidatesTags: ["Create"],
    }),
    generateAuditPdf: builder.mutation({
      query: (parameters) => ({
        url: `/Modimpxx/Auditask/generatePdf`,
        method: "POST",
        body: { TARIDXXX: parameters.TARIDXXX },
        headers: { modulecima: "modimpxx" },
      }),
    }),
    updateMdimPaqinsdx: builder.mutation({
      query: (parameters) => ({
        url: `/Modimpxx/Paqinsdx/updateMdim`,
        method: "POST",
        body: parameters,
        headers: { Modulecima: "Modimpxx" },
      }),
    }),
    updateMdimPreatedi: builder.mutation({
      query: (parameters) => ({
        url: `/Modimpxx/Paqinsdx/updateMdimPreatedi`,
        method: "POST",
        body: parameters,
        headers: { Modulecima: "Modimpxx" },
      }),
    }),
    downloadDocuments: builder.mutation({
      query: (parameters) => ({
        url: `/Modimpxx/Emilibxx/Entransx/downloadDocuments`,
        method: "GET",
        params: parameters,
      }),
    }),
    checkDownloadStatus: builder.query({
      query: (id) => ({
        url: `/Modimpxx/Emilibxx/Entransx/checkDownloadStatus/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLazyValidatePermissionAdminQuery,
  useLazyValidateSyncRecoQuery,
  useLazyValidateSyncRecoMassiveQuery,
  useGetAllTasksMutation,
  useGetRelatedTasksMutation,
  useGetUserResolveMutation,
  useUpdateTaskMutation,
  useChangeStatusTaskMutation,
  useUpdateTaskMassiveMutation,
  useGetEstadosCims30Query,
  useSaveTaskGeneralMutation,
  useUpdateTaskGeneralMutation,
  useAddFollowUpMutation,
  useGetMotivesRejectionQuery,
  useLazyGetFollowUpsQuery,
  useLazyGetMotivesRejectionQuery,
  useSaveFollowUpsMutation,
  useAsigDescMinMutation,
  useGetTributosQuery,
  useGetUrlRedirectionTaskMutation,
  useLazyGetPucByTributosQuery,
  useGetProvAsigvuceQuery,
  useGetDetailTaskQuery,
  useLazyGetConsultProductQuery,
  useLazyGetShortLinkChildTaskQuery,
  useLazyGetShortLinkByModuleQuery,
  useSaveTaskConcepCobroMutation,
  useLazyGetExternalAdminUsersQuery,
  useScheduleTaskByIdMutation,
  useGetDetailProductQuery,
  useApproveOrDeclineMutation,
  useLazyGetUsersQuery,
  useGetProvInvoiceQuery,
  useGetChildTaskQuery,
  useGetCountryProvQuery,
  useUpdateResCheduleTaskMutation,
  useUploadMassiveResCheduleTasksMutation,
  useSaveTaskAsodoentMutation,
  useLazyGetConsultOperationQuery,
  useGetConsultDoVuceQuery,
  useGetIndicatorsByIdQuery,
  useGetInfoTaskFatherQuery,
  useCanResolveTaskQuery,
  useSaveDataCarrierDeliveryMutation,
  useSolveMassiveTasksMutation,
  useGenerateAuditPdfMutation,
  useUpdateMdimPaqinsdxMutation,
  useUpdateMdimPreatediMutation,
  useDownloadDocumentsMutation,
  useCheckDownloadStatusQuery,
  useLazyCheckDownloadStatusQuery,
} = TareasxxApiSlice;
